/**
 * **Desbravador**
 *
 * @exports bs_230
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
       * @memberOf module:bs_230
       * @see {@link prestart}
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot() {
        const $ = window.jQuery;
        let $pageLoading;
        let $bookingStepsTab;
        let $calendar;
        let $bcModal; // Booking Confirmed Modal that contains the Booking ID
        // Some pages display a full blank loading page
        if (!thn.desbravadorPageLoading) {
            $pageLoading = $ && $('#page-loading');
            if ($pageLoading && $pageLoading.length) {
                // Define full page update function
                thn.desbravadorPageLoading = thn.debounce(function thnDesbravadorPageLoading() {
                    if (!$pageLoading.is(':visible')) {
                        thn.languageCheck();
                        // Page check once not visible
                        setTimeout(thn.pageCheck, 250);
                    }
                }, 250);
                // Start observation on full page loading icon
                thn.observeDom($pageLoading.get(0), thn.desbravadorPageLoading, {
                    childList: false,
                    subtree: false,
                    characterData: false,
                    attributes: true,
                    attributeFilter: ['style', 'class'],
                });
                thn.shutdown(function () {
                    thn.stopObserveDom($pageLoading.get(0), thn.desbravadorPageLoading);
                    delete thn.desbravadorPageLoading;
                });
            }
        }
        // When changing between different booking steps
        if (!thn.desbravadorBookingStep) {
            $bookingStepsTab = $ && $('.tab-content');
            if ($bookingStepsTab && $bookingStepsTab.length) {
                // Define booking step change function
                thn.desbravadorBookingStep = thn.debounce(function thnDesbravadorBookingStep() {
                    // Page check!
                    setTimeout(thn.pageCheck, 250);
                }, 250);
                // Start observation on booking steps tab
                thn.observeDom($bookingStepsTab.get(0), thn.desbravadorBookingStep, {
                    childList: true,
                    subtree: false,
                    attributes: true,
                });
                thn.pageUnload(function () {
                    thn.stopObserveDom($bookingStepsTab.get(0), thn.desbravadorBookingStep);
                    delete thn.desbravadorBookingStep;
                });
            }
        }
        // When switching between calendar and R&R page
        if (!thn.desbravadorCalendarObserver) {
            $calendar = $ && $('#home-calendar');
            if ($calendar && $calendar.length) {
                // Define calendar observer
                thn.desbravadorCalendarObserver = thn.debounce(function thnDesbravadorCalendarObserver() {
                    // Page check!
                    setTimeout(thn.pageCheck, 250);
                }, 750);
                // Start observation on calendar div
                thn.observeDom($calendar.get(0), thn.desbravadorCalendarObserver, {
                    childList: false,
                    subtree: false,
                    attributes: true,
                });
                thn.shutdown(function () {
                    thn.stopObserveDom($calendar.get(0), thn.desbravadorCalendarObserver);
                    delete thn.desbravadorCalendarObserver;
                });
            }
        }
        if (!thn.desbravadorBcObserver) {
            $bcModal = $ && $('#modal-pagamento');
            if ($bcModal && $bcModal.length) {
                // Define Booking Confirmed modal observer
                thn.desbravadorBcObserver = thn.debounce(function thnDesbravadorCalendarObserver() {
                    if ($bcModal.find('#btn-checkin').length || $bcModal.find('button#btn-novareserva, button#btn-sitehotel').length === 2) {
                        thn.logger.debug('[Booking Confirmed]!');
                        setTimeout(thn.pageCheck, 250);
                    }
                }, 250);
                // Start observation on the BC Modal
                thn.observeDom($bcModal.get(0), thn.desbravadorBcObserver, {
                    childList: true,
                    subtree: true,
                    attributes: false,
                });
                thn.shutdown(function () {
                    thn.stopObserveDom($bcModal.get(0), thn.desbravadorBcObserver);
                    delete thn.desbravadorBcObserver;
                });
            }
        }
    };
    /**
       * @memberOf module:bs_230
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            thn.domReady().then(function () {
                const $ = window.jQuery;
                const lang = {
                    Español: 'es',
                    Português: 'pt',
                    English: 'en',
                };
                // If in the BE, check de dropdown
                // Higher priority, as HTML tag does not change, so trust the selector.
                let aux = $ && $('#idioma-active span').text();
                aux = aux && lang[aux];
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                // Home page
                aux = $ && (document.documentElement.lang || '').substr(0, 2);
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                // http://nadaiconforthotel.com.br/ - No html lang
                if (thn.data.propertyId === 1015900) {
                    resolve('pt');
                    return;
                }
                reject('no_language');
            }); // on domReady
        });
    };
    /**
       * @memberOf module:bs_230
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const $ = window.jQuery;
        let $roomsLoading;
        // It may be a spinner waiting for rooms to appear
        if (!thn.desbravadorRoomsLoading) {
            $roomsLoading = $ && $('#escolhaquarto-content');
            if ($roomsLoading && $roomsLoading.length) {
                // Define rooms container update function
                thn.desbravadorRoomsLoading = thn.debounce(function thnDesbravadorRoomsLoading() {
                    if (!$roomsLoading.find('.quarto-loading').length) {
                        // Try to refresh PW
                        if (ctx.widget.refresh() && !ctx.widget.isSet()) {
                            ctx.widget.hide();
                        }
                    }
                }, 250);
                // Start observation on rooms container
                thn.observeDom($roomsLoading.get(0), thn.desbravadorRoomsLoading, {
                    childList: true,
                    subtree: false,
                    attributes: false,
                });
                // Setup unload
                thn.pageUnload(function () {
                    thn.stopObserveDom($roomsLoading.get(0), thn.desbravadorRoomsLoading);
                    delete thn.desbravadorRoomsLoading;
                    // Unload the PW for proper loading when returning to R&R
                    ctx.widget.reset();
                });
            }
        }
    };
    /**
       * @memberOf module:bs_230
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        const $ = window.jQuery;
        if (!$) {
            return widgetData;
        }
        // If rooms are not visible, wait for the price_observe_dom to trigger a change
        if (!$('#escolhaquarto-content .quarto-loading').length) {
            // Dates
            const dateBegin2 = ($('.start-day').text() || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            const dateEnd2 = ($('.end-day').text() || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            if (dateBegin2 && dateEnd2) {
                widgetData.dateBegin = dateBegin2;
                widgetData.dateEnd = dateEnd2;
            }
            // Guests, Adults & Children
            let price = Number.MAX_VALUE;
            let adults = 2;
            let children = 0;
            $('.list-group-item').each((idx, room) => {
                const priceRoom = thn.parseNumber($(room).find('.tarifa-price-average').text());
                if (priceRoom && (priceRoom < price)) {
                    price = priceRoom;
                    adults = parseInt($(room).find('.input-adult').val(), 10) || 2;
                    children = parseInt($(room).find('.btn-criancas').text(), 10) || 0;
                }
            });
            widgetData.adults = adults;
            widgetData.children = children;
            widgetData.guests = widgetData.adults + widgetData.children;
            // Prices & Currency || No Rooms
            if (price !== Number.MAX_VALUE) {
                widgetData.price = price;
                widgetData.currency = 'BRL';
                widgetData.set = true;
            }
            else {
                widgetData.noRooms = true;
            }
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_230
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const $ = window.jQuery;
        if (!$) {
            return widgetData;
        }
        // Booking Data
        const bookingId = ($('#modal-pagamento h3').text() || '').match(/\(([^)]+)/);
        widgetData.bookingId = bookingId.length > 1 ? bookingId[1] : '';
        // Dates
        const dateBegin2 = ($('.start-day').text() || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
        const dateEnd2 = ($('.end-day').text() || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
        if (dateBegin2 && dateEnd2) {
            widgetData.dateBegin = dateBegin2;
            widgetData.dateEnd = dateEnd2;
        }
        // Price & Currency
        widgetData.price = thn.parseNumber($('#pagamento-input-total').val());
        widgetData.currency = 'BRL';
        return widgetData;
    };
    return engine;
}

export { factory };
